import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { MaintenanceDisplayData } from "@/models/MaintenanceDisplayData";

export function MaintenanceReferenceCell(
  params: GridRenderCellParams<MaintenanceDisplayData, string>,
) {
  const value = params.row.workOrderJob.id;
  const { database } = useGeotabClient();
  if (!value) return null;

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // prevent row selection / edit mode
    window.open(
      `https://my.geotab.com/${database}/#maintenanceWorkJobDetails,id:${value}`,
      "_blank",
    );
  };
  if (!params.value || params.value == "") return null;

  return (
    <Tooltip title="Open maintenance reference">
      <Link
        component="button"
        onClick={handleClick}
        underline="hover"
        sx={{ cursor: "pointer", color: "primary.main", fontWeight: 500 }}
      >
        #{params.value}
      </Link>
    </Tooltip>
  );
}
